module.exports = __webpack_public_path__ + "img/inco1Ac.7b21871d.png";